import PropTypes from 'prop-types'
import React, { createContext, useContext } from 'react'

import useAuthReducer from './reducer'

export const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const context = useAuthReducer()

  return <AuthContext.Provider value={context}>{children}</AuthContext.Provider>
}
AuthProvider.propTypes = {
  children: PropTypes.node,
}
export const useAuthContext = () => useContext(AuthContext)
